(() => {
  /* Accessory buttons add straight to the cart, one click each. An earlier
     build only marked them as "picked" and folded them into the order button,
     which read as broken: the button turned green but the cart never moved. */

  const CART_DRAWER_ID = 'CartDrawer';
  const FLASH_MS = 2500;

  async function addToCart(button) {
    if (button.dataset.busy === '1') return;

    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    button.dataset.busy = '1';
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      if (!response.ok) throw new Error('add failed');

      if (window.refreshCartUI) await window.refreshCartUI();
      flash(button, button.dataset.labelAdded, 'addon-card__add--on');

      /* Opening the drawer is the clearest possible confirmation, and matches
         what the main order button already does. */
      if (document.getElementById(CART_DRAWER_ID) && window.openDrawer) {
        window.openDrawer(CART_DRAWER_ID);
      }
    } catch (error) {
      flash(button, button.dataset.labelError, 'addon-card__add--error');
    } finally {
      button.removeAttribute('aria-busy');
      button.dataset.busy = '';
    }
  }

  /* Back to "Voeg toe" after a moment, so a second one can be added. */
  function flash(button, text, modifier) {
    const label = button.querySelector('[data-addon-label]');
    if (!label) return;

    window.clearTimeout(Number(button.dataset.timer));
    button.classList.add(modifier);
    label.textContent = text;

    const timer = window.setTimeout(() => {
      button.classList.remove('addon-card__add--on', 'addon-card__add--error');
      label.textContent = button.dataset.labelAdd;
    }, FLASH_MS);

    button.dataset.timer = String(timer);
  }

  /* Delegated so buttons that arrive later — a section re-render in the theme
     editor, for instance — keep working without re-binding. */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-addon-toggle]');
    if (button) addToCart(button);
  });
})();
